import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedFile = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="document" size="100%" color={stroke ?? color} />
);

export { LineRoundedFile };
